import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { SafeHtmlPipePipe } from '../../../shared/pipes/safe-html.pipe';

@Component({
    selector: 'launch-choice',
    templateUrl: './launch-choice.component.html',
    styleUrls: ['./launch-choice.component.scss'],
    standalone: true,
    imports: [SafeHtmlPipePipe]
})
export class LaunchChoiceComponent implements OnInit {

    @Input() message: string;
    @Output() launchNow: EventEmitter<void> = new EventEmitter<void>();
    @Output() launchOnTimer: EventEmitter<void> = new EventEmitter<void>();

    constructor() {}

    ngOnInit() {
    }
}
